import axios from "axios";
import { getUserInfo } from "../General/users";
import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
  get,
} from "firebase/database";
  
export const groundTruthMapping = async (payload, token) => {
  console.log(payload)
  console.log(token)
  if (!token) {
    throw new Error("No auth token found!");
  }
  if(!payload){
    throw new Error("No payload found!");

  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.post(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/ground-truth-mapping",
      payload,
      config
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateGroundTruthMapping = async (payload, token , action) => {
  console.log(payload)
  console.log(token)
  if (!token) {
    throw new Error("No auth token found!");
  }
  if(!payload){
    throw new Error("No payload found!");

  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.post(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/ground-truth-mapping",
      payload,
      config,
      action
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const setEnergyGoal = async (token,energyGoalKw) => {
  // console.log(token)
  if (!token) {
    throw new Error("No auth token found!");
  }
  if (!energyGoalKw) {
    throw new Error("data not found");
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.post(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/set-goal",
      {energyGoalKw}, 
      config
    );
    
    console.log("EVENT RESPONDS",response)
    return response;
  
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const getSetGoal = async(token) =>{  // console.log(token)
  if (!token) {
    throw new Error("No auth token found!");
  }
  
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

   try {
    const response = await axios.get("https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/goal",config);
    
    return response;
  
  } catch (error) {
    console.log(error);

    throw error;
  }


}

export const fetchUserEnergyData = async (deviceId) => {
  const db = getDatabase();
  const userQuery = query(
    ref(db, "dev-energy-sharing-table"),
    orderByChild("deviceId"),
    equalTo(deviceId)
  );
  const snapshot = await get(userQuery);
  if (snapshot.exists()) {
    return Object.values(snapshot.val());
  } else {
    return [];
  }

};
export const getHistoricalBaseLine = async ( token)=>{
    if (!token) {
    throw new Error("No auth token found!");
  }
  
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get("https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/baseline",  config);
    
    return response
  } catch (error) {
    console.log(error);
    throw error;
  }}
export const getSavedEnergy = async ( token)=>{
  if (!token) {
  throw new Error("No auth token found!");
}

const config = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};
try {
  const response = await axios.get("https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/saved-energy?monthYear=2025-07",  config);
  
  return response
} catch (error) {
  console.log(error);
  throw error;
}}
// export const getGrandTruthMapping = async (token) => {
//   const config = {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   };

//   try {
//     const response = await axios.get(
//       "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/my-ground-truth",
//       config
//     );

//     // Ensure nested data exists
//     const raw = response?.data?.data;
//     if (!raw) {
//       throw new Error("API response data is missing");
//     }

//     const formatAppliances = (appliances) =>
//       Array.isArray(appliances)
//         ? appliances.map((item) => ({
//             label: item.name || item.type || item.label || "Unnamed",
//             value: item.value ?? "-",
//           }))
//         : [];

//     return {
//       Facility: formatAppliances(raw.facilityAppliances),
//       Home: formatAppliances(raw.homeAppliances),
//       Others: formatAppliances(raw.others),
//     };
//   } catch (error) {
//     console.error("getGrandTruthMapping error:", error);
//     throw error;
//   }
// };

export const getGrandTruthMapping = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get("https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/my-ground-truth", config);
    return response;
  } catch (error) {
    throw error;
  }
}



export const getEnergyMeter = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get("https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/energy-meter", config);
    return response;
  } catch (error) {
    throw error;
  }
}

export const getHistoricalBaseLineHistory = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get("https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy-efficiency/improvement-baseline-history", config);
    return response;
  } catch (error) {
    throw error;
  }
}

